
import Vue from "vue";
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {
    PossibleToApplyForEndorsement, ResultError,
    StartApplyingOrChangeTypeClient, 
    StartApplyingForEndorsementRequest,
    ChangeTypeToEndorsementRequest
} from "@/api-client";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import Loader from "@/features/shared/components/Loader";
import { Prop } from "vue-property-decorator";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";

interface Props {
    seafarerId: string;
    applicationId?: string;
    btnClass: string;
}

@Component({
    components: {
        ButtonWithConfirm,
        HeadingWave,
        SectionPageHeading,
        TableEmptySlot
    }
})
export default class EndorsementTypeTable extends Vue implements Props {
    @Prop({ required: true })
    seafarerId!: string;
    @Prop({ required: false })
    applicationId!: string;
    @Prop({ required: false, default: 'btn-wide' })
    btnClass!: string;

    error: ResultError | null = null;
    applicationTypes: PossibleToApplyForEndorsement[] = [];

    loader = new Loader();

    fields = [
        { key: 'name', label: this.$ls.Global_Label_CertificateTypeName, sortable: true },
        { key: 'documentTypeCode', label: this.$ls.Global_Label_DocumentType, sortable: true },
        { key: 'linkIcon', label: '', sortable: false, thClass: 'w-20', tdClass: 'table-actions' }
    ];

    async created() {
        this.applicationTypes = await new StartApplyingOrChangeTypeClient().getEndorsementsToApplyFor(this.seafarerId);
    }

    startApplyingOrChangeType(templateId: string, certificateId: string) {
        this.error = null;

        if(this.applicationId){
            const request = new ChangeTypeToEndorsementRequest({
                templateId,
                certificateId,
                appId: this.applicationId
            });
            new StartApplyingOrChangeTypeClient()
                .setLoader(this.loader)
                .changeTypeToEndorsement(request, this.seafarerId)
                .then(() => this.$router.go(0), error => this.error = error);
        }
        else{
            const request = new StartApplyingForEndorsementRequest({
                templateId,
                certificateId
            });
            new StartApplyingOrChangeTypeClient()
                .setLoader(this.loader)
                .startApplyingForEndorsement(request, this.seafarerId)
                .then(result => this.$router.push({
                    name: "ApplicationOverview",
                    params: { applicationId: result.applicationId }
                }), error => this.error = error);
        }
    }
}
